<ion-header>
  <ion-toolbar>
    <ion-buttons>
      <ion-back-button></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="article">
  <ion-grid class="article-content">
    <ion-row>
      <ion-col id="title_col" size="1200">
        <ion-text>
          <!-- Parsed title block -->
          <ng-container *ngIf="!translateMode; else plainTitleBlock">
            <ion-row size="1200" id="title_sentence_row">
              <ion-col size="1200" id="title_sentence_col">
                <ion-text id="title-text">
                  <span class="title-sentence">
                    <span *ngFor="let wordToken of title_parsed; let i = index"
                          [ngClass]="wordToken.isKeyWord ? 'title_key_word_span' : 'title_word_span'"
                          (click)="openWordDetails(wordToken.text, i, true)"
                          [attr.dir]="getDirection()">
                      {{ wordToken.text }}
                    </span>
                  </span>
                </ion-text>
              </ion-col>
            </ion-row>
          </ng-container>
          <ng-template #plainTitleBlock>
            <ion-row id="title_sentence_row">
              <ion-col id="title_sentence_col">
                <ion-text *ngIf="translateMode">
                  {{ getArticleTitle(nativeLang, selectedLevel) }}
                </ion-text>
              </ion-col>
            </ion-row>
          </ng-template>
          <!-- Publisher info -->
          <div class="publisher-info">
            <img *ngIf="article.publisherIcon" class="publisher-image" alt="publisher image" [src]="article.publisherIcon">
            <p>{{ article.publisher }}</p>
          </div>
          <p></p>
        </ion-text>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col id="share_panel" size="1200">
        <ion-buttons>
          <!--
          <ion-button>
            <ion-icon name="share"></ion-icon>
          </ion-button>
          -->
          <ion-button (click)="toggleBookMark()">
            <ion-icon *ngIf="!bookmarked" name="bookmark-outline"></ion-icon>
            <ion-icon *ngIf="bookmarked" name="bookmark"></ion-icon>
          </ion-button>
          <ion-button (click)="goToArticle()">
            <ion-icon name="link"></ion-icon>
          </ion-button>
          <ion-button *ngIf="article" (click)="translate()">
            <ion-icon *ngIf="!loadingTranslation" name="language-outline"></ion-icon>
            <ion-spinner *ngIf="loadingTranslation"></ion-spinner>
          </ion-button>
          <ion-button *ngIf="article && !isAudioPlaying()" (click)="vocalize()">
            <ion-icon *ngIf="!loadingAudio" name="volume-high-outline"></ion-icon>
            <ion-spinner *ngIf="loadingAudio"></ion-spinner>
          </ion-button>
          <ion-button *ngIf="article && isAudioPlaying()" (click)="stopAudio()">
            <ion-icon name="stop-outline"></ion-icon>
          </ion-button>
          <ion-button (click)="decreaseTextSize()" [disabled]="getCurrentTextSize() === 1">
            <ion-icon name="remove-outline"></ion-icon>
          </ion-button>
          <ion-button (click)="increaseTextSize()" [disabled]="getCurrentTextSize() === 5">
            <ion-icon name="add-outline"></ion-icon>
          </ion-button>
          <ion-button (click)="toggleDarkMode()">
            <ion-icon [name]="isDarkMode() ? 'sunny-outline' : 'moon-outline'"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-col>
    </ion-row>
    <ion-row id="article_image">
      <ion-col id="image_col" size="1200">
        <ion-img 
          [src]="article.imageUrl"
          [style.max-width]="isTouring ? '250px' : null">
        </ion-img>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col id="difficulty_col" size="1200">
        <ion-segment *ngIf="selectedLevel" mode="ios" id="difficulty_panel" value="{{ selectedLevel }}" (ionChange)="changeLevel($event)">
          <ion-segment-button value=1>{{ 'ARTICLE.LEVEL' | translate }} 1</ion-segment-button>
          <ion-segment-button value=2>{{ 'ARTICLE.LEVEL' | translate }} 2</ion-segment-button>
          <ion-segment-button value=3>{{ 'ARTICLE.LEVEL' | translate }} 3</ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>
    <ion-row id="article_row">
      <ion-col id="article_col">
        <ng-container *ngIf="!translateMode; else plainTextBlock">
          <ion-row id="sentence_row" *ngFor="let sentence of article_parsed; let i = index">
            <ion-col id="sentence_col" [attr.dir]="getDirection()" [class.rtl]="getDirection() === 'rtl'">
              <ion-text>
                <span
                  [ngClass]="wordToken.isKeyWord ? 'key_word_span' : 'word_span'"
                  title="Tap Words" text="Tap a word to pull up the definition."
                  *ngFor="let wordToken of sentence"
                  (click)="openWordDetails(wordToken.text, i)"
                  [attr.dir]="getDirection()"
                  [attr.id]="wordToken.text === 'EZ Knews' && isTouring ? 'example_word' : null"
                >
                  {{ wordToken.text }}
                </span>
              </ion-text>
            </ion-col>
          </ion-row>
        </ng-container>
        <ng-template #plainTextBlock>
          <ion-row id="sentence_row">
            <ion-col id="sentence_col">
              <ion-text *ngIf="translateMode">
                {{ getArticleText(nativeLang, selectedLevel) }}
              </ion-text>
            </ion-col>
          </ion-row>
        </ng-template>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>